import api from './axiosConfig';

export const employeeApi = {
  getEmployees: () => api.get('/v1/employees'),
  getEmployeeDetails: (id) => api.get(`/v1/employees/${id}`),
  addEmployee: (data) => api.post('/v1/employees', data),
  updateEmployee: (id, data) => api.put(`/v1/employees/${id}`, data),
  deleteEmployee: (id) => api.delete(`/v1/employees/${id}`),
  downloadIDCard: (id) => api.get(`/v1/employees/${id}/idcard`, { responseType: 'blob' }),
  
  // Transactions
  getTransactions: (id) => api.get(`/v1/employees/${id}/transactions`),
  addTransaction: (id, data) => api.post(`/v1/employees/${id}/transactions`, data),
  
  // Attendance
  getAttendance: (id, params) => api.get(`/v1/employees/${id}/attendance`, { params }),
  getAllAttendance: (params) => api.get(`/v1/employees/attendance`, { params }),
  markAttendance: (id, data) => api.post(`/v1/employees/${id}/attendance`, data),
  bulkMarkAttendance: (data) => api.post(`/v1/employees/bulk-attendance`, data),
};
